import * as React from "react";
import type { SVGProps } from "react";
const SvgOpenInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#041E78"
      fillRule="evenodd"
      d="M2 2.474C2 1.66 2.672 1 3.5 1h9c.828 0 1.5.66 1.5 1.474v11.79a.74.74 0 0 1-.407.654.76.76 0 0 1-.779-.055l-2.189-1.536-2.19 1.536a.76.76 0 0 1-.87 0l-2.19-1.536-2.19 1.536a.76.76 0 0 1-.778.055.74.74 0 0 1-.407-.655zm3 3.008c0-.406.336-.736.75-.736h4.5c.414 0 .75.33.75.736a.744.744 0 0 1-.75.737h-4.5A.744.744 0 0 1 5 5.482m.75 2.211c-.414 0-.75.33-.75.737s.336.737.75.737h4.5c.414 0 .75-.33.75-.737a.744.744 0 0 0-.75-.737z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOpenInvoice;
